var _circle, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 96,
    fill: "url(#paint0_linear_227_110)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.27 42C120.988 41.9952 114.96 44.4675 110.51 48.8744C106.06 53.2814 103.551 59.2626 103.535 65.5054V91.5674C101.09 91.7314 98.5912 91.8343 96 91.8343C93.4088 91.8343 90.9215 91.9376 88.465 92.0832V65.5054C88.3651 59.3168 85.8206 53.4153 81.3809 49.0739C76.941 44.7326 70.9616 42.2995 64.7325 42.2995C58.5034 42.2995 52.524 44.7326 48.0841 49.0739C43.6443 53.4153 41.0999 59.3168 41 65.5054V127.794C41.0999 133.983 43.6443 139.884 48.0841 144.225C52.524 148.567 58.5034 151 64.7325 151C70.9616 151 76.941 148.567 81.3809 144.225C85.8206 139.884 88.3651 133.983 88.465 127.794V101.732C90.9096 101.568 93.4088 101.465 96 101.465C98.5912 101.465 101.078 101.361 103.535 101.216V127.794C103.635 133.983 106.179 139.884 110.619 144.225C115.059 148.567 121.038 151 127.268 151C133.497 151 139.476 148.567 143.916 144.225C148.356 139.884 150.9 133.983 151 127.794V65.5054C150.984 59.2637 148.476 53.2833 144.027 48.8766C139.579 44.4699 133.552 41.9968 127.27 42ZM64.7295 51.6305C68.4373 51.6289 71.9944 53.0888 74.6204 55.69C77.2462 58.2912 78.7264 61.8212 78.7361 65.5054V93.1035C71.7926 94.1033 65.0119 96.0082 58.5695 98.769C55.7781 99.9863 53.1504 101.545 50.7472 103.408V65.5054C50.7569 61.8254 52.2337 58.2991 54.8543 55.6986C57.4749 53.0981 61.0258 51.6353 64.7295 51.6305ZM78.7361 127.794C78.7361 131.485 77.2604 135.025 74.6336 137.635C72.0069 140.245 68.4443 141.711 64.7295 141.711C61.0146 141.711 57.452 140.245 54.8252 137.635C52.1985 135.025 50.7228 131.485 50.7228 127.794V121.546C50.7228 116.026 55.1228 110.798 62.4989 107.543C67.6963 105.315 73.1496 103.731 78.7361 102.825V127.794ZM127.27 141.669C123.562 141.67 120.006 140.211 117.38 137.609C114.754 135.008 113.274 131.478 113.264 127.794V100.196C120.207 99.1963 126.988 97.2914 133.43 94.5306C136.222 93.3132 138.849 91.7549 141.253 89.8914V127.794C141.243 131.474 139.766 135 137.146 137.601C134.525 140.201 130.974 141.664 127.27 141.669ZM129.501 85.7197C124.304 87.9477 118.851 89.5322 113.264 90.4378V65.5054C113.264 61.8143 114.74 58.2744 117.366 55.6643C119.993 53.0543 123.556 51.588 127.27 51.588C130.985 51.588 134.548 53.0543 137.175 55.6643C139.802 58.2744 141.277 61.8143 141.277 65.5054V71.7537C141.277 77.249 136.877 82.4772 129.501 85.7197Z",
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_110",
    x1: 12.16,
    y1: 177.695,
    x2: 179.202,
    y2: 10.6552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69FABD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/One.bdcaae26486ae05f58c8bc0fa6f59de4.svg";
export { ForwardRef as ReactComponent };